import React from 'react';

import { useIntl } from 'react-intl';

import { FilterProductIcon } from '../../../../../common/ui/filters/filter-product-icon';
import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import SelectFilter from '../../../../../common/ui/filters/select-filter';
import { useSelectFilter } from '../../../../../controllers/filters/base-select-filter';
import { usePrimaryProduct } from '../../../../../controllers/store/bootstrap';
import { filter as pullRequestStatusFilter } from '../../../../../controllers/store/search/filters/pull-request-status';
import { i18n } from './messages';

const PullRequestStatusFilter = ({
	isFilterInDropdown,
	showPrimaryProductIcon,
	fit = 'default',
	onFilterChange,
	hideOnHoverOut,
}: FilterProps): React.JSX.Element | null => {
	const [primaryProduct] = usePrimaryProduct();
	const { formatMessage } = useIntl();
	const [filterData, { loadInitialOptions, setOption }] = useSelectFilter({
		filterId: pullRequestStatusFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const { isLoading, selectedOptions, options } = filterData;

	const label =
		fit === 'compact' && selectedOptions.length > 0
			? ''
			: formatMessage(i18n.pullRequestStatusLabel);

	return (
		<SelectFilter
			contentFit={fit}
			onDropdownOpen={loadInitialOptions}
			onSelectChange={(option, ...restArgs) => {
				setOption(option, ...restArgs);
				onFilterChange?.(option);
			}}
			options={options}
			selectedOptions={selectedOptions}
			label={label}
			filterOrControlId={'pullRequestStatus'}
			isLoading={isLoading}
			isFilterInDropdown={isFilterInDropdown}
			checkboxIndicators
			iconBefore={
				<FilterProductIcon
					showPrimaryProductIcon={showPrimaryProductIcon}
					primaryProduct={primaryProduct}
				/>
			}
			hideOnHoverOut={hideOnHoverOut}
		/>
	);
};

export default PullRequestStatusFilter;
